import { render } from "./faturacao_v2.vue?vue&type=template&id=17601a00&scoped=true"
import script from "./faturacao_v2.vue?vue&type=script&lang=js"
export * from "./faturacao_v2.vue?vue&type=script&lang=js"

import "./faturacao_v2.vue?vue&type=style&index=0&id=17601a00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17601a00"]])

export default __exports__